<template>
    <div class="grid grid-cols-1 gap-4 sm:grid-cols-2">
        <div @click.prevent="selectType(item)" v-for="item in types"
             class="relative rounded-lg border border-gray-300 bg-white px-6 py-5 shadow-sm flex items-center space-x-3 hover:border-gray-400 focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-indigo-500">
            <div class="flex-shrink-0">
                <component :is="item.icon"
                           :class="[item.current ? 'text-gray-500' : 'text-gray-400 group-hover:text-gray-500', 'mr-4 flex-shrink-0 h-6 w-6']"
                           aria-hidden="true"/>
            </div>
            <div class="flex-1 min-w-0">
                <a href="#" class="focus:outline-none">
                    <span class="absolute inset-0" aria-hidden="true"></span>
                    <p class="text-sm font-medium text-gray-900">{{ item.title }}</p>
                    <p class="text-sm text-gray-500">{{ item.description }}</p>
                </a>
            </div>
            <CheckCircleIcon :class="[!item.checked ? 'invisible' : '', 'h-5 w-5 text-indigo-600']" aria-hidden="true" />
        </div>
    </div>
</template>

<script>
import {
    AtSymbolIcon,
    ChatBubbleBottomCenterIcon,
    ChatBubbleLeftRightIcon,
    DocumentIcon,
    DocumentTextIcon,
    IdentificationIcon,
    LinkIcon,
    MapPinIcon,
    PhoneIcon,
    PhotoIcon,
    ShoppingCartIcon,
    WifiIcon
} from '@heroicons/vue/24/outline'
import {CheckCircleIcon} from '@heroicons/vue/24/solid'
import code_types from "@/scripts/store/code_types";

export default {
    components: {
        CheckCircleIcon,
        LinkIcon,
        WifiIcon,
        MapPinIcon,
        AtSymbolIcon,
        PhoneIcon,
        ChatBubbleLeftRightIcon,
        PhotoIcon,
        DocumentIcon,
        ChatBubbleBottomCenterIcon,
        DocumentTextIcon,
        IdentificationIcon,
        ShoppingCartIcon
    },

    props: {
        selectedType: {
            default: 'link'
        }
    },

    data() {
        return {
            types: code_types,

            fields: {
                link: {
                    link: ''
                },
                email: {
                    email: ''
                },
                call: {
                    phone: ''
                },
                text: {
                    text: ''
                },
                sms: {
                    phone: '',
                    body: '',
                },
                geolocation: {
                    latitude: '',
                    longitude: '',
                },
                pdf: {
                    fileId: '',
                },
                linktoapp: {
                  apple: '',
                  google: ''
                },
                vcard: {
                    first_name: '',
                    last_name: '',
                    phone: '',
                    email: '',
                    city: '',
                    country: '',
                    street: '',
                    url: ''
                },
                totelegram: {
                    phone: '',
                    body: ''
                },
                towhatsapp: {
                    phone: '',
                    body: ''
                },
                messenger: {
                    items: [
                        {
                            type: 'telegram',
                            checked: true,
                            phone: '',
                            text: ''
                        },
                        {
                            type: 'whatsapp',
                            checked: true,
                            phone: '',
                            text: ''
                        }
                    ],
                    fallback: {
                        type: 'sms',
                        phone: '',
                        text: ''
                    }
                }
            }
        }
    },

    mounted() {
        this.types.forEach(type => {
            type.checked = type.type === this.selectedType;
        })
    },

    methods: {
        selectType(item) {
            this.types.forEach(type => {
                type.checked = type.type === item.type;
            })

            this.$emit('changed', {type: item.type, fields: this.fields[item.type]})
        }
    }
}
</script>
